import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import * as actions from '../../actions';

import SelectButton from './SelectButton';
import Image from './Image';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.css';
import Scroll, { scroller } from 'react-scroll';
import MediaQuery from "react-responsive";

import tracking from '../../services/Tracking';

class SelectButtonGroup extends React.Component {

  constructor(props) {
    super(props);

    this.handleOptionChange = this.handleOptionChange.bind(this);
    this.handleCarouselChange = this.handleCarouselChange.bind(this);

    this.state = {
      currentSlide: 0,
    };

    this.isMobile = !window.matchMedia("(min-width: 768px)").matches;
  }

  componentDidMount() {
    const { index, configData: { slug }, isScrollIndicatorVisible, setLastQuestionId } = this.props;

    setLastQuestionId(slug);

    if (index > 0 && !isScrollIndicatorVisible) {
      this.scrollIntoView();
    }
  }

  scrollIntoView() {
    const { configData: { slug }, isScrollIndicatorVisible, hideScrollIndicator } = this.props;

    if (this.isMobile && isScrollIndicatorVisible) {
      hideScrollIndicator();
    }
    setTimeout(()=>{
      const element = document.querySelector(`[name=question_${slug}]`);
      if(element){
        scroller.scrollTo(`question_${slug}`, {
          smooth: true,
          offset: element.getBoundingClientRect().height - window.innerHeight + 50,
          duration: 900,
        });
      }
    }, 500);
  }

  handleOptionChange(buttonIndex, changeEvent) {

    const { configData, showScrollIndicator, saveSelected } = this.props;
    const { options, swipeable } = configData;

    const answer = options[buttonIndex];
    if (answer) {
      tracking.event(answer.text, this.props.configData.slug);
    }

    if (swipeable) {
      this.setState({
        currentSlide: buttonIndex,
      });
      if (this.isMobile) {
        showScrollIndicator();
      }
    }

    //check if selected product leads to an result
    const { id, value, name } = changeEvent.target;
    options.map(element => {
      if (element.id == id) {
        this.setState({
          selectedOption: id,
        });
        //selection has a result - push result in store and show results button
        saveSelected({
          group: name,
          id: id
        });
      }
    });
  }

  handleCarouselChange(currentSlide) {
    const { configData: { swipeable, options }, showScrollIndicator, saveSelected } = this.props;

    const compareArray = options.filter(option => option.visible).map((compare) => compare.id);

    this.setState({
      selectedOption: compareArray[currentSlide],
      currentSlide,
    });

    if (this.isMobile && swipeable) {
      if (this.isMobile) {
        showScrollIndicator();
      }
    }

    const id = options[currentSlide].id;
    if(document.getElementById(id)){
      const group = document.getElementById(id).name;

      saveSelected({
        group,
        id,
      });
    }
  }

  render() {
    const { configData, index } = this.props;

    if (configData === undefined) {
      console.warn('data undefined: ', configData); // eslint-disable-line no-console
      return null;
    }

    const { currentSlide } = this.state;
    const { slug, question, value, swipeable, additionalClass: additionalClassnames } = configData;

    const options = configData.options.filter(option => option.visible);
    // define col width
    //const colWidth = 12 / options.length;
    const colWidth = options.length < 5 ? 12 / options.length : 'custom';

    return (
      <Scroll.Element name={`question_${slug}`} className="element">
        <div className={'question ' + additionalClassnames}>
          <div className="row">
            <div className="col">
              <h1 className="text-uppercase headline headline--centerOnMD headline--h1 headline--question">
                <span className="headline__inner"><FormattedMessage id={question} defaultMessage={question} /></span>
              </h1>
            </div>
          </div>
          {swipeable ? (
            <div className="">
              <MediaQuery maxWidth={767} className="row">
                <div className="row">
                  <div className="col">
                    <Carousel
                      axis="horizontal"
                      showThumbs={false}
                      showArrows={true}
                      showStatus={false}
                      showIndicators={true}
                      selectedItem={currentSlide}
                      onChange={this.handleCarouselChange}>
                      {options.map((answer, j) => (
                        <div key={j}>
                          {
                            answer.image &&
                            <Image data={answer} swipeable={swipeable} buttonIndex={j} name={index + 1} id={answer.id} onClick={this.handleOptionChange} />
                          }
                        </div>
                      ))}
                    </Carousel>
                  </div>
                </div>
              </MediaQuery>
              <MediaQuery minWidth={768} className="row">
                {options.length > 4 ? (

                <div className="row">
                  {options.map((answer, j) => (
                    <div className={'col-sm-12 col-md-' + colWidth} key={j}>
                      {
                        answer.image &&
                        <Image data={answer} swipeable={swipeable} buttonIndex={j} name={index + 1} id={answer.id} onClick={this.handleOptionChange} />
                      }
                        <SelectButton
                        buttonIndex={j}
                        buttonText={<FormattedMessage id={answer.text} defaultMessage={answer.text} />}
                        id={answer.id}
                        name={index + 1}
                        icon={answer.buttonIcon}
                        selected={value}
                        onChange={this.handleOptionChange} />

                    </div>
                  ))}
                </div>
                ) : (
                  <div className="row">
                    {options.map((answer, j) => (
                      <div className={'col-sm-12 col-md-' + colWidth} key={j}>
                        {
                          answer.image &&
                          <Image data={answer} swipeable={swipeable} buttonIndex={j} name={index + 1} id={answer.id} onClick={this.handleOptionChange} />
                        }
                      </div>
                    ))}
                  </div>
                )}
              </MediaQuery>
            </div>
          ) : (
            <div className="row">
              {options.map((answer, j) => (
                <div className={'col-sm-12 col-md-' + colWidth} key={j}>
                  {answer.image && <Image data={answer} swipeable={swipeable} buttonIndex={j} name={index + 1} id={answer.id} onClick={this.handleOptionChange} />}
                </div>
              ))}
            </div>
          )}
          {options.length <= 4 ? (
          <div className="row">
            {options.map((answer, j) => (
              <div className={'col-sm-12 col-md-' + colWidth} key={j}>
                <SelectButton
                  buttonIndex={j}
                  buttonText={<FormattedMessage id={answer.text} defaultMessage={answer.text} />}
                  id={answer.id}
                  name={index + 1}
                  icon={answer.buttonIcon}
                  selected={value}
                  onChange={this.handleOptionChange} />
              </div>
            ))}
          </div>
          ) :('')}
        </div>
      </Scroll.Element>
    );
  }
}

SelectButtonGroup.propTypes = {
  configData: PropTypes.shape({
    options: PropTypes.array,
    swipeable: PropTypes.bool,
    additionalClass: PropTypes.string,
    track_action: PropTypes.string,
    slug: PropTypes.string,
  }),
  setLastQuestionId: PropTypes.func.isRequired,
  showScrollIndicator: PropTypes.func.isRequired,
  hideScrollIndicator: PropTypes.func.isRequired,
  isScrollIndicatorVisible: PropTypes.bool.isRequired,
  saveSelected: PropTypes.func.isRequired,
  index: PropTypes.number.isRequired,
};

function mapStateToProps(state) {
  return {
    showResults: state.configurator.showResults,
    isScrollIndicatorVisible: state.configurator.showScrollIndicator,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    showScrollIndicator: () => actions.setScrollIndicator(true)(dispatch),
    hideScrollIndicator: () => actions.setScrollIndicator(false)(dispatch),
    setLastQuestionId: (id) => actions.setLastQuestionId(id)(dispatch),
    saveSelected: (payload) => actions.saveSelected(payload)(dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(SelectButtonGroup);



// WEBPACK FOOTER //
// ./src/components/selectButton/SelectButtonGroup.js